import React from "react";
import { LogOut } from "react-feather";
import { useTranslation } from "react-i18next";
import { useStores } from "../../../../hooks/useStores";
import { Avatar, AvatarInitial } from "../../../UI/Avatar";
import { Dropdown, DropdownToggle } from "../../../UI/Dropdown";
import {
  StyledDropMenu,
  StyledAuthorName,
  StyledAuthorRole,
  StyledDropItem,
  StyledDivider,
  StyledAvatar,
} from "./style";

type Props = {
  handleSignOut: () => void;
};

const ProfileDropdown: React.FC<Props> = ({ handleSignOut }) => {
  const { session } = useStores();
  const { t } = useTranslation();

  return (
    <Dropdown direction="down" className="dropdown-profile">
      <DropdownToggle variant="texted">
        <StyledAvatar size="sm" shape="circle">
          <AvatarInitial>{session.user?.nominative?.charAt(0)}</AvatarInitial>
        </StyledAvatar>
      </DropdownToggle>
      <StyledDropMenu>
        <Avatar size="lg" shape="circle">
          <AvatarInitial>{session.user?.nominative?.charAt(0)}</AvatarInitial>
        </Avatar>
        <StyledAuthorName>{session.user?.email}</StyledAuthorName>
        <StyledAuthorRole>{session.user?.role}</StyledAuthorRole>
        <StyledDivider />
        <StyledDropItem mt="10px" onClick={handleSignOut} path="/login">
          <LogOut size="24" />
          {t("common.signOut")}
        </StyledDropItem>
      </StyledDropMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
